<script setup lang="ts">
import type { Category } from '@shared/types/models'
import DropdownLink from '@/components/Navbar/Dropdown/DropdownLink.vue'

interface Props {
    categories: Category[]
    mainSlug: string
    secondSlug?: string
}

const { categories, mainSlug, secondSlug } = defineProps<Props>()
</script>

<template>
    <aside
        class="flex border-l-2 lg:border-l-0 border-border absolute top-full lg:top-[52px] left-2 right-0 lg:right-auto lg:left-auto bg-page shadow-md border-t z-20 lg:-ml-5 transition-all"
    >
        <div class="w-full flex flex-col">
            <dropdown-link
                v-if="categories"
                v-for="category in categories"
                :key="category.id"
                :category="category"
                :main-slug="mainSlug"
                :second-slug="secondSlug || category.slug"
            />
        </div>
    </aside>
</template>
